<template>
    <div>
        <div class="text-center">
            <div style="font-size: 16px;"><strong>Proyección de Ventas</strong></div>
            <br />
        </div>        
        <CDataTable
          class="projection-table"
            :hover="true"
            :striped="true"
            :border="true"
            :small="true"
            :fixed="true"
            :items="items"
            :fields="fields"
            :items-per-page="50"
            pagination
            :noItemsView="{ noResults: 'No se encontraron elementos', noItems: 'Sin Elementos' }"
            >         
              <template #brand="{item}">
                <td class="table_actions cell-12 brand-cell text-center">
                  <strong>{{ item.brand }}</strong>
                </td>
              </template>   
              <template #first_year="{item}">
                <td class="text-center cell-12 amount-cell metric-cell">
                  ${{ item.first_year }}
                  <small class="d-block text-muted customers-meta text-center">{{ item.first_year_customers || '0' }} clientes</small>
                </td>
              </template>   
              <template #last_year="{item}">
                <td class="text-center cell-12 amount-cell amount-cell-current metric-cell">
                  <strong>${{ item.last_year }}</strong>
                  <small class="d-block text-muted customers-meta text-center">{{ item.last_year_customers || '0' }} clientes</small>
                </td>
              </template>   
              <template #so="{item}">
                <td class="text-center cell-12 metric-cell">
                  ${{ item.so }}
                </td>
              </template>   
              <template #projection="{item}">
                <td class="text-center cell-12 metric-cell">
                  ${{ item.projection }}
                </td>
              </template>   
              <template #variation="{item}">
                <td
                  class="text-center cell-12 metric-cell metric-strong"
                  :class="getVariationCellClass(item)"
                >
                  <span
                    class="sales-delta"
                    :class="getVariationSalesClass(item)"
                  >
                    <span v-if="!(item.variation_sales_plus || item.variation_plus)">-</span> ${{ item.variation }}
                  </span>
                  <small
                    class="d-block customers-meta customers-delta"
                    :class="getVariationCustomersClass(item)"
                  >
                    <span>{{ getCustomersDeltaValue(item) }}</span>
                    <span v-if="!isCustomersDeltaZero(item)" class="customers-label"> clientes</span>
                  </small>
                </td>
              </template>   
              <template #variation_sales_rate="{item}">
                <td
                  class="text-center cell-12 metric-cell metric-strong"
                  :class="getSalesMetricClass(item)"
                >
                  <span v-if="!(item.variation_sales_plus || item.variation_plus)">-</span> {{ item.variation_sales_rate || item.variation_rate }}%
                </td>
              </template>
              <template #variation_customers_rate="{item}">
                <td
                  class="text-center cell-12 metric-cell metric-strong"
                  :class="getCustomersMetricClass(item)"
                >
                  <span v-if="!item.variation_customers_plus">-</span> {{ item.variation_customers_rate }}%
                </td>
              </template>               
        </CDataTable>
    </div>
</template>

<script>
// import ws from '@/services/graphs';

import ws from '../../services/dashboards';
import store from '../../store'

const FIELD_STYLE = 'font-size: 14px;';

export default {
    name: 'ProjectionTable',
    props: {
        permissions: {
            type: Object,
            default() {
                return {}
            }
        },
        title: {
            type: String,
            default() {
                return "Proyección de Ventas"
            }
        },
        month: {
            type: String,
            default: '202401'
        }           
    },
    components : {
	},
    data: function () {
		    return {
            data: [],
            items: [],
            root: null,
            fields: [
              {key: 'brand', label: 'Proveedor (Marca)', _style: FIELD_STYLE},
              {key: 'first_year', label: '2023', _style: FIELD_STYLE},
              {key: 'last_year', label: '2024', _style: FIELD_STYLE},
              {key: 'projection', label: 'Proyección', _style: FIELD_STYLE},
              {key: 'variation', label: 'Var $', _style: FIELD_STYLE},
              {key: 'variation_sales_rate', label: 'Var Ventas %', _style: FIELD_STYLE},
              {key: 'variation_customers_rate', label: 'Var Clientes %', _style: FIELD_STYLE}
            ],
            is_past: false  
        }
    },
    computed: {
        
    },
    mounted: async function(){
        await this.reloadGraph(this.month);
    },
    methods: {
        getFields(isPast, previousLabel, currentLabel){
            const fields = [
              {key: 'brand', label: 'Proveedor (Marca)', _style: FIELD_STYLE},
              {key: 'first_year', label: previousLabel, _style: FIELD_STYLE},
              {key: 'last_year', label: currentLabel, _style: FIELD_STYLE},
            ];

            if(!isPast){
              fields.push(
                {key: 'projection', label: 'Proyección', _style: FIELD_STYLE}
              );
            }

            fields.push(
              {key: 'variation', label: 'Var $', _style: FIELD_STYLE},
              {key: 'variation_sales_rate', label: 'Var Ventas %', _style: FIELD_STYLE},
              {key: 'variation_customers_rate', label: 'Var Clientes %', _style: FIELD_STYLE}
            );

            return fields;
        },
        async reloadGraph(month, brand){
            this.loading();

            try {
              const response = await ws.getProjectionSales(month, brand);

              if(response.type !== "success"){
                return;
              }

              const payload = response.data || {};

              this.data = payload.data || [];
              this.is_past = !!payload.is_past;
              this.fields = this.getFields(this.is_past, payload.label_2, payload.label_1);
              this.items = this.data;
            } finally {
              this.loaded();
            }
        },
        loading(){
            store.commit('loading');
        },
        loaded(){
            store.commit('loaded');
        },
        getRateClass (rateValue, isPositive) {
            const rate = this.parseRate(rateValue);
            const signedRate = isPositive ? rate : -rate;

            if (signedRate > 75) {
              return 'metric-achievement';
            }

            if (signedRate >= 20) {
              return 'metric-normal';
            }

            if (signedRate >= 0) {
              return 'metric-warning';
            }

            return 'metric-negative';
        },
        getSalesMetricClass (item) {
            return this.getRateClass(
              item.variation_sales_rate || item.variation_rate,
              item.variation_sales_plus || item.variation_plus
            );
        },
        getCustomersMetricClass (item) {
            return this.getRateClass(item.variation_customers_rate, item.variation_customers_plus);
        },
        isVariationFullAchievement (item) {
          return this.getSalesMetricClass(item) === 'metric-achievement'
            && this.getCustomersMetricClass(item) === 'metric-achievement';
        },
        getVariationCellClass (item) {
          return this.isVariationFullAchievement(item) ? 'metric-achievement' : '';
        },
        getVariationSalesClass (item) {
          return this.isVariationFullAchievement(item) ? '' : this.getSalesMetricClass(item);
        },
        getVariationCustomersClass (item) {
          return this.isVariationFullAchievement(item) ? '' : this.getCustomersMetricClass(item);
        },
        parseRate (value) {
            const normalized = String(value ?? '0').replace(/,/g, '');
            const parsed = Number(normalized);
            return Number.isFinite(parsed) ? parsed : 0;
        },
        getCustomersDeltaValue (item) {
            const variationCustomers = String(item.variation_customers ?? '0');

            if (variationCustomers === '0') {
              return 'Sin Aumento';
            }

            if (item.variation_customers_plus) {
              return `+${variationCustomers}`;
            }

            return `-${variationCustomers}`;
        },
        isCustomersDeltaZero (item) {
            return String(item.variation_customers ?? '0') === '0';
        }
    },
    beforeDestroy() {
        if (this.root) {
            this.root.dispose();
        }
  }
}

</script>

<style scoped>
.cell-12 {
  font-size: 13px;
  padding: 4px 8px !important;
  line-height: 1.25;
}

.metric-cell {
  font-size: 17px;
}

.metric-strong {
  font-weight: 700;
}

.customers-meta {
  font-size: 17px;
  line-height: 1.2;
  margin-top: 1px;
  text-align: center !important;
}

.customers-delta {
  font-size: 17px;
  font-weight: 600;
  margin-top: 4px;
}

.sales-delta {
  display: inline-block;
}

.sales-delta.metric-achievement,
.customers-delta.metric-achievement {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
}

.customers-label {
  color: inherit;
}

.brand-cell {
  background-color: #f6f7f9;
}

.amount-cell {
  background-color: #fbfbfb;
}

.amount-cell-current {
  background-color: #f1f6ff;
}

.metric-achievement {
  background-color: #198754;
  color: #ffffff;
}

.metric-negative {
  color: #c4493d;
}

.metric-warning {
  color: #b06d15;
}

.metric-normal {
  color: inherit;
}

.projection-table ::v-deep td {
  text-align: center !important;
}
</style>
